import { render, staticRenderFns } from "./Aluno.vue?vue&type=template&id=faa12062&"
import script from "./Aluno.vue?vue&type=script&lang=js&"
export * from "./Aluno.vue?vue&type=script&lang=js&"
import style0 from "./Aluno.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports